import ajaxProxy from '../globs/ajax-proxy';
import config from '../globs/config';
import subscribeNotifications from './firebase-notifications';


export default function salesOfficerRefresh(user) {
  const salesOfficerId = user.id;
  const url = `${config.apiContextPath}/sales_officers/${salesOfficerId}`;
  return (dispatch) => {
      ajaxProxy
        .dataLoad({
          key: 'userLaod',
          url: url
        })
        .then((res) => {
          dispatch({ type: 'UPDATE_USER', payload: res.data });
          dispatch(subscribeNotifications(res.data))
        });
    
  };
}

